import { useMemo } from 'react';
import { connect } from 'react-redux';

import asArray from 'utils/arrays/asArray.util';
import asObject from 'utils/objects/asObject.util';

import EmailItem from 'checkout/components/EmailItem';

const STYLE_NO_PADDING = Object.freeze({ padding: 0 });

const STYLE_CLIENT_NAME_CELL = Object.freeze({
  borderTop: '1px solid #e5e5e5',
  backgroundColor: '#fff',
  textAlign: 'left',
  verticalAlign: 'middle',
  fontFamily: 'sans-serif',
});

const STYLE_CLIENT_NAME = Object.freeze({
  marginLeft: '42px',
  marginBottom: '6px',
  textAlign: 'left',
  fontSize: '14px',
  fontFamily: 'sans-serif',
  textTransform: 'capitalize',
});

const STYLE_CLIENT_DOT_CONTAINER = Object.freeze({
  borderTop: '1px solid #e5e5e5',
  backgroundColor: ' #fff',
  textAlign: 'right',
  verticalAlign: 'middle',
  fontFamily: 'sans-serif',
});

const STYLE_SERVICES_CELL = Object.freeze({
  backgroundColor: ' #fff',
  padding: '0 50px',
});

const STYLE_CLIENT_DOT = Object.freeze({
  textAlign: 'right',
  fontSize: '14px',
  fontFamily: 'Open Sans,sans-serif',
  color: '#fff',
  marginRight: '48px',
});

const EmailClient = ({ client, clients, tableStyle }) => {
  const clientFromProps = asObject(client);
  const allClients = asArray(clients);

  const resolvedClient = useMemo(() => {
    if (!clientFromProps.id) {
      return undefined;
    }

    return allClients.find((c) => c.id === clientFromProps.id);
  }, [clientFromProps.id, allClients]);

  const userName = asObject(resolvedClient).user_name;
  const { products, services } = asObject(clientFromProps);

  return (
    <tr data-bem="EmailClient">
      <td colSpan="2" style={STYLE_NO_PADDING}>
        <table style={tableStyle}>
          <tbody>
            <tr key="client">
              <td height="36" style={STYLE_CLIENT_NAME_CELL}>
                {resolvedClient && <h2 style={STYLE_CLIENT_NAME}>{userName}</h2>}
              </td>
              <td style={STYLE_CLIENT_DOT_CONTAINER}>
                <p style={STYLE_CLIENT_DOT}>.</p>
              </td>
            </tr>

            <tr key="services">
              <td colSpan="2" style={STYLE_SERVICES_CELL}>
                <p>
                  {asArray(services).map((service) => (
                    <EmailItem tableStyle={tableStyle} itemType="service" item={service} key={service.id} />
                  ))}
                  {asArray(products).map((product) => (
                    <EmailItem tableStyle={tableStyle} itemType="product" item={product} key={product.id} />
                  ))}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
  );
};

const mapStateToProps = (state) => ({ clients: state.currentSalon.clientList });

const EmailClientHoc = connect(mapStateToProps)(EmailClient);

export default EmailClientHoc;
